import { Home } from "./components/Home/Home";
import  { Navbar } from "./components/Shared/Navbar";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Signup from "./components/auth/Signup";
import { Login } from "./components/auth/Login";
import { Room } from "./components/Roooms/Room";
import { Roomdetails } from "./components/Roooms/Roomdetails";
import { YourRooms } from "./components/Roooms/YourRooms";
import { User } from "./components/User/User";
import { Editroom } from "./components/Roooms/Editroom";
import { Forgetpassword } from "./components/auth/Forgetpassword";
import { MainPage } from "./components/Home/MainPage";
import { Footer } from "./components/Home/Footer";
import Requests from "./components/Roooms/Requests";


export default function App() {
  return (
    <Router>
      
        <Navbar />
        <Routes>
        <Route path="/" element={<MainPage/>}  />
          <Route path="/signup" element={<Signup/>}  />
          <Route path="/home" element={<Home/>}  />
          <Route path="/login" element={<Login/>}  />
          <Route path="/createpost" element={<Room/>}  />
          <Route path="/yourposts" element={<YourRooms/>}  />
          <Route path="/room/:roomId" element={<Roomdetails/>}  />
          <Route path="/myprofile" element={<User/>}  />
          <Route path="/edit-room/:roomId" element={<Editroom/>}  />
          <Route path="/forgot-password" element={<Forgetpassword/>}  />
          <Route path="/requests" element={<Requests/>}  />
          
        </Routes>
        <Footer/>
      
      
    </Router>
  )
}